import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Stats from './components/Stats';
import Career from './components/Career';
import Projection from './components/Projection';
import Videos from './components/Videos';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <div className="App bg-black text-white min-h-screen">
          <Header />
          <main>
            <Hero />
            <About />
            <Stats />
            <Career />
            <Projection />
            <Videos />
            <Gallery />
            <Contact />
          </main>
          <Footer />
          <Toaster />
        </div>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
